module.exports = __webpack_public_path__ + "assets/img/jtfx55.caaebdd3.png";